// Tool to help with maintaining ideal aspect ratios.
$(function() {
	var attribute = 'force-aspect-ratio';
	var forced = $('[' + attribute + ']');

	forced.each(function() {
		var aspectRatio = forced.attr(attribute).split('x');
		var aspectRatio = aspectRatio[1] / aspectRatio[0];
		$(this).data('aspectRatio', aspectRatio);
	});

	$window.resize(function() {
		forced.each(function() {
			resizeElement(this);
		});
	}).trigger('resize');
});

function resizeElement(element){
	$(element).height('');
	$(element).width('');
	var aspectRatio = $(element).data('aspectRatio');
	$(element).removeClass('width_constrained height_constrained');
	if ($window.height() > $window.width() * aspectRatio) {
		$(element).addClass('width_constrained');
		$(element).height($(element).width() * aspectRatio);
	} else {
		$(element).addClass('height_constrained');
		$(element).width($(element).height() / aspectRatio);
	}
};